export const AIActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 3.97168C7.07847 5.04006 7.95905 5.92139 9.02734 6.5C7.9593 7.07848 7.07848 7.9593 6.5 9.02734C5.92139 7.95905 5.04006 7.07847 3.97168 6.5C5.04031 5.92139 5.92139 5.04031 6.5 3.97168Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M13.5 7.84863C14.5399 10.413 16.5861 12.4599 19.1504 13.5C16.5864 14.54 14.54 16.5864 13.5 19.1504C12.4599 16.5861 10.413 14.5399 7.84863 13.5C10.4133 12.46 12.46 10.4133 13.5 7.84863Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
